export enum Shape {
  CIRCLE = 'CIRCLE',
  RECTANGLE = 'RECTANGLE',
}
